import { render, staticRenderFns } from "./FcreList.vue?vue&type=template&id=3c335df0&scoped=true&"
import script from "./FcreList.vue?vue&type=script&lang=js&"
export * from "./FcreList.vue?vue&type=script&lang=js&"
import style0 from "./FcreList.vue?vue&type=style&index=0&id=3c335df0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c335df0",
  null
  
)

export default component.exports